import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterSidebarComponent} from './filter-sidebar/filter-sidebar.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [
    FilterSidebarComponent
  ],
  imports: [
    CommonModule,
	MatCheckboxModule,
	FormsModule
  ],
  exports:[
	// FilterSidebarComponent
  ]
})
export class FilterSidebarModule { }
